"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

var _Icon = _interopRequireDefault(require("../Icon"));

var _BatteryPercentageChart = require("../BatteryPercentageChart");

require("react-vis/dist/style.css");

var _DownloadCsv = _interopRequireDefault(require("../DownloadCsv"));

var _ChartStyles = require("../ChartStyles");

var _Display = _interopRequireDefault(require("./Display"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _InteractionWithBattery = _interopRequireDefault(require("./InteractionWithBattery"));

var _FixedYAxisChart = _interopRequireDefault(require("../FixedYAxisChart"));

var _Scrollable = _interopRequireDefault(require("../Scrollable"));

var _propTypes2 = require("../../constants/propTypes");

var _ChartLoader = _interopRequireDefault(require("../ChartLoader"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Relative = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var FifteenMinuteChart = /*#__PURE__*/function (_PureComponent) {
  _inherits(FifteenMinuteChart, _PureComponent);

  var _super = _createSuper(FifteenMinuteChart);

  function FifteenMinuteChart() {
    var _this;

    _classCallCheck(this, FifteenMinuteChart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      focusedBattery: 'Battery 1',
      isToggleActive: true
    };

    _this.setToggleState = function () {
      var isToggleActive = _this.state.isToggleActive;
      return _this.setState({
        isToggleActive: !isToggleActive
      });
    };

    _this.setFocusedBattery = function (b) {
      return _this.setState({
        focusedBattery: b
      });
    };

    return _this;
  }

  _createClass(FifteenMinuteChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          averageBatteryCoordinates = _this$props.averageBatteryCoordinates,
          coordinatesGroupedByTime = _this$props.coordinatesGroupedByTime,
          displayCoordinates = _this$props.displayCoordinates,
          endMillis = _this$props.endMillis,
          hasBattery = _this$props.hasBattery,
          hasConsumption = _this$props.hasConsumption,
          individualBatteryCoordinates = _this$props.individualBatteryCoordinates,
          individualBatteryKeys = _this$props.individualBatteryKeys,
          internalUsage = _this$props.internalUsage,
          isLoading = _this$props.isLoading,
          startMillis = _this$props.startMillis,
          storageProfile = _this$props.storageProfile,
          timeZone = _this$props.timeZone,
          viewEndDateTime = _this$props.viewEndDateTime,
          viewStartDateTime = _this$props.viewStartDateTime,
          withBatteryChart = _this$props.withBatteryChart;
      var _this$state = this.state,
          focusedBattery = _this$state.focusedBattery,
          isToggleActive = _this$state.isToggleActive;
      var yTickRange = (0, _chartUtils.getMinMaxRangeFromDisplayCoordinates)(displayCoordinates);
      var downloadFields = [{
        label: 'Time',
        value: 'friendlyDate'
      }, {
        label: 'Solar (kW)',
        value: 'solar'
      }];

      if (hasBattery || internalUsage) {
        var batteryCharge = {
          label: 'Battery Charge (kW)',
          value: 'charge'
        };
        var batteryDischarge = {
          label: 'Battery Discharge (kW)',
          value: 'discharge'
        };
        downloadFields.push(batteryCharge);
        downloadFields.push(batteryDischarge);
      }

      if (hasConsumption) {
        var consumption = {
          label: 'Consumption (kW)',
          value: 'consumption'
        };
        var selfConsumption = {
          label: 'Self Consumption (kW)',
          value: 'selfConsumption'
        };
        var exportValue = {
          label: 'Export (kW)',
          value: 'exportValue'
        };
        var importValue = {
          label: 'Import (kW)',
          value: 'importValue'
        };
        downloadFields.push(consumption);
        downloadFields.push(selfConsumption);
        downloadFields.push(exportValue);
        downloadFields.push(importValue);
      }

      return /*#__PURE__*/_react["default"].createElement(Relative, null, /*#__PURE__*/_react["default"].createElement(_ChartLoader["default"], {
        isLoading: isLoading
      }), /*#__PURE__*/_react["default"].createElement(_FixedYAxisChart["default"], {
        hasNoData: false,
        yTickRange: yTickRange,
        handleTickFormat: function handleTickFormat(t) {
          return "".concat(t, " kW");
        }
      }), /*#__PURE__*/_react["default"].createElement(_Scrollable["default"], null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartLeft, {
        "data-tour": "chart-area"
      }, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
        displayCoordinates: displayCoordinates,
        endMillis: endMillis,
        hasBattery: hasBattery,
        isLoading: isLoading,
        startMillis: startMillis,
        timeZone: timeZone
      }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, hasBattery && withBatteryChart ? /*#__PURE__*/_react["default"].createElement(_InteractionWithBattery["default"], {
        coordinatesGroupedByTime: coordinatesGroupedByTime,
        endMillis: endMillis,
        focusedBattery: focusedBattery,
        hasBattery: hasBattery,
        individualBatteryCoordinates: individualBatteryCoordinates,
        individualBatteryKeys: individualBatteryKeys,
        isToggleActive: isToggleActive,
        setFocusedBattery: this.setFocusedBattery,
        startMillis: startMillis,
        timeZone: timeZone
      }) : /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
        coordinatesGroupedByTime: coordinatesGroupedByTime,
        endMillis: endMillis,
        hasBattery: hasBattery,
        startMillis: startMillis,
        timeZone: timeZone
      }))), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartRight, null, /*#__PURE__*/_react["default"].createElement(_DownloadCsv["default"], {
        hideMobile: true,
        data: Object.values(coordinatesGroupedByTime).sort(_chartUtils.sortCoordinatesDescending).map(function (row) {
          return _objectSpread({
            friendlyDate: _luxon.DateTime.fromMillis(row.x, {
              zone: timeZone
            }).toISO()
          }, row);
        }),
        fields: downloadFields,
        fileName: "Fifteen Minute Interval ".concat(viewStartDateTime.toISODate(), " to ").concat(viewEndDateTime.toISODate()),
        style: {
          position: 'absolute',
          right: 0,
          bottom: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        style: {
          height: 31,
          width: 31
        },
        name: "DownloadIcon"
      })))), hasBattery && withBatteryChart && /*#__PURE__*/_react["default"].createElement(_ChartStyles.BatteryPercentageChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_BatteryPercentageChart.BatteryPercentageControls, {
        individualBatteryKeys: individualBatteryKeys,
        isToggleActive: isToggleActive,
        setToggleState: this.setToggleState,
        storageProfile: storageProfile
      }), /*#__PURE__*/_react["default"].createElement(_BatteryPercentageChart.BatteryPercentageDisplay, {
        averageBatteryCoordinates: averageBatteryCoordinates,
        endMillis: endMillis,
        focusedBattery: focusedBattery,
        isLoading: isLoading,
        individualBatteryCoordinates: individualBatteryCoordinates,
        individualBatteryKeys: individualBatteryKeys,
        isToggleActive: isToggleActive,
        startMillis: startMillis,
        timeZone: timeZone
      }))), hasBattery && withBatteryChart && /*#__PURE__*/_react["default"].createElement(_FixedYAxisChart["default"], {
        hasNoData: false,
        tickValues: ['0', '50', '100'],
        handleTickFormat: function handleTickFormat(t) {
          return "".concat(t, " %");
        },
        chartHeight: "100px",
        yTickRange: [0, 100],
        bottom: "0"
      }));
    }
  }]);

  return FifteenMinuteChart;
}(_react.PureComponent);

FifteenMinuteChart.propTypes = {
  averageBatteryCoordinates: _propTypes2.coordinatePropTypes,
  coordinatesGroupedByTime: _propTypes2.groupedCoordinatePropTypes,
  displayCoordinates: _propTypes["default"].shape({
    batteryChargeCoordinates: _propTypes2.coordinatePropTypes,
    batteryDischargeCoordinates: _propTypes2.coordinatePropTypes,
    consumptionCoordinates: _propTypes2.coordinatePropTypes,
    exportAreaCoordinates: _propTypes2.coordinatePropTypes,
    selfConsumptionCoordinates: _propTypes2.coordinatePropTypes,
    solarCoordinates: _propTypes2.coordinatePropTypes
  }),
  endMillis: _propTypes["default"].number.isRequired,
  hasBattery: _propTypes["default"].bool,
  hasConsumption: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  individualBatteryCoordinates: _propTypes["default"].shape({
    'Battery 1': _propTypes2.coordinatePropTypes
  }),
  internalUsage: _propTypes["default"].bool,
  individualBatteryKeys: _propTypes["default"].arrayOf(_propTypes["default"].string),
  startMillis: _propTypes["default"].number.isRequired,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }),
  timeZone: _propTypes["default"].string,
  viewEndDateTime: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  viewStartDateTime: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  withBatteryChart: _propTypes["default"].bool.isRequired
};
FifteenMinuteChart.defaultProps = {
  averageBatteryCoordinates: [],
  coordinatesGroupedByTime: {},
  displayCoordinates: {},
  hasBattery: false,
  hasConsumption: false,
  isLoading: false,
  individualBatteryCoordinates: {},
  individualBatteryKeys: [],
  internalUsage: false,
  storageProfile: {},
  timeZone: 'local'
};
var _default = FifteenMinuteChart;
exports["default"] = _default;